import { IonButton } from '@ionic/react';
import { SheetLayout, SheetModal, ThemeSwitcher } from '@mobile/ui';
import { Section } from '@shared/ui';

export interface SettingsSheetProps {
  /** 面板是否開啟。IonModal 為常駐元件，以此控制而非條件渲染 */
  isOpen: boolean;
  onClose: () => void;
}

/**
 * 設定面板。
 *
 * **沒有 footer。**裡面每個項目都是按下即生效（主題切換立刻套用並記住），
 * 沒有東西需要提交——硬掛一條「取消／儲存」只會讓人以為選了亮色還要再按儲存。
 * 這與 diet 的系統設定頁是同一個判斷。
 */
export function SettingsSheet({ isOpen, onClose }: SettingsSheetProps) {
  return (
    <SheetModal
      isOpen={isOpen}
      onClose={onClose}
      /* 設定項只有外觀一組，面板取剛好容得下的高度，不留大片空白 */
      heightClass="[--height:45%]"
    >
      <SheetLayout
        title="設定"
        /* 關閉鍵放 header：這一頁沒有提交概念，底部不該出現看似要確認的按鈕 */
        headerEnd={
          <IonButton onClick={onClose} className="text-muted-foreground">
            <span className="text-sm">完成</span>
          </IonButton>
        }
      >
        <Section
          title="外觀"
          hint="預設為亮色。選擇會記在這台裝置上，下次開啟沿用。"
        >
          <ThemeSwitcher />
        </Section>

        <Section title="關於">
          <p className="text-xs leading-relaxed text-muted-foreground">
            照片全程在這台裝置上轉換，不會上傳到任何伺服器。關閉網路也能使用。
          </p>
        </Section>
      </SheetLayout>
    </SheetModal>
  );
}
